import axios from 'axios';

const hasBillingAddress = (userInfo) => !!(userInfo.line1 || '').trim() || !!(userInfo.company || '').trim();

export default async (state, commit, getters) => {
    let payload = {
        instantOn: getters.instantOn,
        tracking: JSON.stringify(state.tracking),
        timezone: state.userInfo.timezone,
        currency: state.userInfo.currency,
    };

    if (!!getters.token) {
        payload = {
            ...payload,
            token: getters.token,
        }
    } else {
        payload = {
            ...payload,
            userInfo: {
                firstName: state.userInfo.firstName,
                lastName: state.userInfo.lastName,
                email: state.userInfo.email,
                phone: state.userInfo.phone,
            },
            // Only sent when the customer filled the address step, so callers without the address form
            // (or a half-filled store) never submit a placeholder-looking address to eHawk or billing.
            ...(hasBillingAddress(state.userInfo) && {
                billingAddress: {
                    company: state.userInfo.company.trim(),
                    line1: state.userInfo.line1.trim(),
                    city: state.userInfo.city.trim(),
                    stateCode: state.userInfo.state,
                    postalCode: state.userInfo.postalCode.trim(),
                    countryCode: state.userInfo.billingCountry,
                },
            }),
            ...(state.purchaseInfo.flow && {flow: state.purchaseInfo.flow}),
            talon: state.talon,
            ...(getters.token && {token: getters.token}),
            ...(state.purchaseInfo.partnerAccountId && {partnerAccountId: state.purchaseInfo.partnerAccountId}),
            ...(state.purchaseInfo.linkPostedBy && {linkPostedBy: state.purchaseInfo.linkPostedBy}),
            ...(state.purchaseInfo.bundleId && {bundleId: state.purchaseInfo.bundleId}),
            ...(state.purchaseInfo.sourceCode && {adPartner: state.purchaseInfo.sourceCode}),
            ...(!!getters.recaptchaToken && {
                recaptchaToken: getters.recaptchaToken,
                recaptchaAction: 'FREE_TRIAL_SIGNUP'
            }),
            ...(getters.isTestBox && {requestCampaign: 'architecture.FreeTrialTestBox'}),
            transactionId: getters.transactionId,
            ...(!!state.purchaseInfo.linkId && {linkId: state.purchaseInfo.linkId}),
        };
    }
    let response;
    if (!!getters.token) {
        response = await axios.post('/api/v1/subscription/jwt-trial', {
            ...payload
        });
    } else {
        response = await axios.post('/api/v1/subscription/trial', {
            ...payload
        });
    }

    if (response.data.subscriptionId) {
        commit('updateChargebeeInfo', { subscriptionId: response.data.subscriptionId });
    }
    if (response.data.provisioningId) {
        commit('setProvisioningId', response.data.provisioningId);
    }
    if (getters.isTestBox && !!response.data.location) {
        commit('updateRedirectLocation', response.data.location);
    }
    // The trial flow no longer creates a user, so response.data.user may be absent.
    if (!getters.isTestBox && response.data.user) {
        commit('updateUserInfo', { userId: response.data.user.id, jwt: response.data.user.jwt });
    }
}
